import { Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import { useDoorConfigurationsApi } from "../../../../api/door_configurations_api";
import { getCurrentUser } from "../../../../core/common_functions";
import { NullableString } from "../../../../core/common_types";
import { Allegati } from "../../../../models/allegati";
import { QuoteAccessory, QuoteSummary } from "../../../../models/door_configuration";
import { useConfigurationsService } from "../../../../services/configurations_service";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";
import { AmountItem } from "../../door/builder/conditions_pagev2";
import HomeIcon from "@mui/icons-material/Home";
import DownloadIcon from "@mui/icons-material/Download";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import EditIcon from "@mui/icons-material/Edit";
import SendIcon from "@mui/icons-material/Send";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { usePergolaConfigurationBuilderActions } from "../../../../../store/reducers/pergola_configuration_builder";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PergolaFinal from "./components/pergola-draw/PergolaFinal";

export const QuotePage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatcher = useStoreDispatch();
    const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
    const { resetSteps } = usePergolaConfigurationBuilderActions();
    const [isBusy, setIsBusy] = useState(false);
    const [quote, setQuote] = useState<{ progress: boolean, summary: QuoteSummary, error: NullableString }>({ progress: true, summary: null, error: null });
    const currentUser = getCurrentUser(base);
    const doorConfigurationsApi = useDoorConfigurationsApi();
    const [selectedFiles, setSelectedFiles] = useState<Allegati[]>([]);
    const configurationService = useConfigurationsService();
    const pergolaService = useConfigurationsServicePergola();
    const screenshotFn = useRef<(() => Promise<void> | void) | null>(null);
    const [closures, setClosures] = useState<any[]>([]);
    const isOrderSent = () => {
        return "order_sent" == quote.summary?.data?.status || 
        "order_confirmed" == quote.summary?.data?.status;
    }
    const inviaOrdine = async () => {
        setIsBusy(true);
        try {
            //await configurationService.sendOrder(currentUser, Number(id));

            alert("L'ordine è stato inviato con successo");

            navigate("/configurations");
        } catch (e: any) {
            setIsBusy(false);

            let message = "";
            if (typeof e == "string") {
                message = e;
            } else {
                if (e.severity == "error") {
                    message = e.message;
                } else if (e.severity == "warning") {
                    message = e.message;
                }
            }
            setQuote({ progress: false, summary: null, error: message });
        }
    }
     const buildPdf = async (target: string) => {
        setIsBusy(true);
        try {
            if (!pergolaConfigurationBuilder.configuration) throw "invalid configuration";
            setIsBusy(false);
            window.open(`${process.env.REACT_APP_WEB_URL}/pergola-configurations/${id}/${target}/pdf`);
        } catch (e: any) {
            setIsBusy(false);
        }
    }
    const loadQuote = async () => {
        try {
            if (!pergolaConfigurationBuilder.configuration) throw "invalid configuration";

            let summary = await pergolaService.getQuote(currentUser, Number(id));

            // Le chiusure non sono bloccanti per il preventivo: se l'API fallisce
            // o risponde con un payload non valido, mostriamo comunque il riepilogo.
            let vetrateArray: any[] = [];
            try {
                const getvetrate: any = await pergolaService.getClosuresAcc(currentUser, Number(id));
                const raw = Array.isArray(getvetrate) ? getvetrate : getvetrate?.data;
                if (Array.isArray(raw)) {
                    vetrateArray = raw;
                } else if (raw && typeof raw === "object") {
                    vetrateArray = Object.values(raw);
                } else {
                    console.warn("getClosuresAcc: payload non valido, ignorato", getvetrate);
                }
            } catch (closuresError) {
                console.error("Errore getClosuresAcc", closuresError);
            }
            setClosures(vetrateArray);
            const files: Allegati[] = await doorConfigurationsApi.getAllegati(
                currentUser,
                Number(id)
            );
            setSelectedFiles(files);
            setQuote({ progress: false, summary, error: null });            
        } catch (e: any) {
            let message = "";
            if (typeof e == "string") {
                message = e;
            } else {
                if (e.severity == "error") {
                    message = e.message;
                } else if (e.severity == "warning") {
                    message = e.message;
                }
            }
            setQuote({ progress: false, summary: null, error: message });
        }
    }
    const dwAllegati= async (allegatoId: string,fileName: string)=> {
        doorConfigurationsApi.downloadAllegato(currentUser,allegatoId,Number(id),fileName)
    }
     const resetPreventivo = async () => {
        setIsBusy(true);
        try {
            if (!pergolaConfigurationBuilder.configuration) throw "invalid configuration";

            await configurationService.resetQuote(currentUser, Number(id));

            dispatcher(resetSteps());

            navigate(`/pergola-configurations/${id}`);
        } catch (e: any) {
            setIsBusy(false);

            let message = "";
            if (typeof e == "string") {
                message = e;
            } else {
                if (e.severity == "error") {
                    message = e.message;
                } else if (e.severity == "warning") {
                    message = e.message;
                }
            }
            setQuote({ progress: false, summary: null, error: message });
        }
    }
    useEffect(() => {
        if (!id || isNaN(Number(id)) || !pergolaConfigurationBuilder.configuration) {
            navigate("/configurations");
        } else {            
            loadQuote();            
        }
    }, []);
    const getDescription = (a: QuoteAccessory): string => {
    let des = a.name ?? "";

    // Se non c'è additionalData → esci subito
    if (!a.additionalData || typeof a.additionalData !== "string" || a.additionalData.trim() === "") {
        return des;
    }

    let data: any = null;

    // Prova a fare il parse, se fallisce ignora tutto
    try {
        data = JSON.parse(a.additionalData);
    } catch {
        return des; // JSON rotto → non aggiungere niente
    }

    // Vetrate: array di lati/colore (es. ["A1", "RAL 9010"])
    if (Array.isArray(data)) {
        const items = data.filter((i): i is string => typeof i === "string" && i.trim().length > 0);
        return items.length ? `${des} - <strong>${items.join(" - ")}</strong>` : des;
    }

    // BLOCCO CRITICO: correggi qui
    if (data == null || typeof data !== "object") {
        return des;
    }

    // Ora siamo 100% sicuri che data è un oggetto non-null e non-array
    if ("notes" in data && data.notes) {
        des += ` - <strong>${data.notes}</strong>`;
    }
    else if ("details" in data && Array.isArray(data.details)) {
        const lines = (data.details as any[])
            .filter((item): item is string => typeof item === "string")
            .map((item) => item.trim())
            .filter((item) => item.length > 0)
            .join("<br />");

        if (lines) {
            des += `<strong>- <br />${lines}</strong>`;
        }
    }

    return des;
};
    return(<>
    <div className="row m-0 h-full" style={{overflowY: window.innerWidth < window.innerHeight ? "auto" : undefined}}>
            <div className="col-xl-6 p-0" style={{position: "relative" }}>
                <PergolaFinal onScreenshotReady={(fn) => (screenshotFn.current = fn)} />
            </div>
            <div className="col-xl-6 p-0 quote-summary" style={{ overflowY: window.innerWidth < window.innerHeight ? undefined : "auto", height: "100%", borderLeft: "solid 1px #ccc" }}>
                <div className="px-4 py-2">
                    <h5 className="text-primary">Riepilogo</h5>
                    {pergolaConfigurationBuilder.configuration && <div className="mt-3">
                        <h6 className="h6 fw-bold" style={{ borderBottom: "solid 1px var(--bs-primary)" }}>PRODOTTO</h6>
                        <table className="w-100">
                            <tbody>
                                <tr>
                                    <td>Pergola</td>
                                    <td className="text-end">&euro; {quote.summary?.data.productPrice}</td>
                                </tr>
                                <tr>
                                    <td><span style={{textTransform: "uppercase"}}>Misure Larghezza x Profondità</span></td>
                                    <td className="text-end">{pergolaConfigurationBuilder.configuration.dimensioni.larghezza}x{pergolaConfigurationBuilder.configuration.dimensioni.profondita} mm</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>}
                    {pergolaConfigurationBuilder.configuration && <div className="mt-3">
                        <h6 className="h6 fw-bold" style={{ borderBottom: "solid 1px var(--bs-primary)" }}>QUANTITÀ</h6>
                        <table className="w-100">
                            <tbody>
                                <tr>
                                    <td>Quantità</td>
                                    <th className="text-end">{quote.summary?.data.qty ?? 1}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>}
                    {pergolaConfigurationBuilder.configuration && <div className="mt-3">
                        <h6 className="h6 fw-bold" style={{ borderBottom: "solid 1px var(--bs-primary)" }}>DIMENSIONI PERGOLA</h6>
                        <table className="w-100">
                            <tbody>
                                <tr>
                                    <td className="border-bottom">Larghezza:</td>
                                    <th className="text-end border-bottom">{pergolaConfigurationBuilder.configuration.dimensioni.larghezza} mm</th>
                                </tr>
                                <tr>
                                    <td className="border-bottom">Profondità:</td>
                                    <th className="text-end border-bottom">{pergolaConfigurationBuilder.configuration.dimensioni.profondita} mm</th>
                                </tr>
                                <tr>
                                    <td className="border-bottom">Altezza:</td>
                                    <th className="text-end border-bottom">{pergolaConfigurationBuilder.configuration.dimensioni.altezza} mm</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>}
                    {pergolaConfigurationBuilder.configuration && <div className="mt-3">
                        <h6 className="h6 fw-bold" style={{ borderBottom: "solid 1px var(--bs-primary)" }}>ACCESSORI</h6>
                        <table className="w-100">
                            <thead>
                                <tr>
                                    <th className="border-bottom" style={{ width: "12%" }}>CODICE</th>
                                    <th className="border-bottom" style={{ width: "60%" }}>DESCRIZIONE</th>
                                    <th className="border-bottom text-end" style={{ width: "8%" }}>Q.TÀ</th>
                                    <th className="border-bottom text-end" style={{ width: "10%" }}>PREZZO U.</th>
                                    <th className="border-bottom text-end" style={{ width: "10%" }}>TOTALE</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {closures.map((item, idx) => {
                                    const qty = Number(item.qty) || 0;
                                    const unitPrice = Number(item.price) || 0;
                                    const total = qty * unitPrice;
                                    const fakeAccessory: QuoteAccessory = {
                                        id: item.sku, // finto, solo per key
                                        sku: item.sku,
                                        name: item.name,
                                        qty: item.qty,
                                        um: item.um,
                                        net: item.net,
                                        price: item.price,
                                        additionalData: item.additionalData,
                                    };
                                    return (
                                        <tr key={`vet-${item.sku}-${idx}`}>
                                            <td className="border-bottom align-top">{item.sku}</td>
                                            <td className="border-bottom" dangerouslySetInnerHTML={{ __html: getDescription(fakeAccessory) }} />
                                            <td className="border-bottom text-end">
                                                {Number(qty.toFixed(2))} {item.um || ""}
                                            </td>
                                            <td className="border-bottom text-end">€ {unitPrice.toFixed(2)}</td>
                                            <td className="border-bottom text-end">€ {total.toFixed(2)}</td>
                                        </tr>
                                    );
                                })}
                                {(Array.isArray(quote.summary?.accessories) ? quote.summary!.accessories : []).filter(a => !["ACCT0113","ACCT01281","ACCT0111"].includes(a.sku ?? "")).map((a, idx) => {
                                    // Convertiamo sempre in numero, con fallback a 0
                                    const productPrice = Number(quote.summary?.data?.productPrice) || 0;
                                    const originalPrice = Number(a.price) || 0;

                                    const price = a.sku === "ACCT015" 
                                        ? productPrice * 0.15 
                                        : originalPrice;

                                    const qty = Number(a.qty) || 0;
                                    const total = qty * price;

                                    return (
                                        <tr key={`${a.id}_${idx}`}>
                                        <td className="border-bottom align-top">{a.sku}</td>
                                        <td className="border-bottom" dangerouslySetInnerHTML={{ __html: getDescription(a) }}></td>
                                        <td className="border-bottom text-end">
                                            {Number(qty.toFixed(2))} {a.um || ""}
                                        </td>
                                        <td className="border-bottom text-end">
                                            € {price.toFixed(2)}
                                        </td>
                                        <td className="border-bottom text-end">
                                            € {total.toFixed(2)}
                                        </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>}
                    {pergolaConfigurationBuilder.configuration && <div className="mt-3">
                        <h6 className="h6 fw-bold" style={{ borderBottom: "solid 1px var(--bs-primary)" }}>TOTALI</h6>
                        <div className="mt-1 rounded-3 p-3 mt-3 bg-light " style={{ position: "relative" }}>                                
                            <div className="d-flex justify-content-between">
                                <AmountItem label="Totale merce:" value={quote.summary?.data.baseNetPrice} />
                            </div>

                            <div className="d-flex justify-content-between">
                                <AmountItem label="Totale servizi:" value={quote.summary?.data.totalServices} />
                            </div>

                            {!currentUser.isCustomer && (
                                <>
                                    <div className="my-1 text-center" style={{ lineHeight: "1" }}>
                                        <hr />
                                        {process.env.NODE_ENV != "production" && <small>Rivendita</small>}
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Sconto:" value={-(quote.summary?.data.retailTotalDiscount ?? 0)} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale merce netto:" value={quote.summary?.data.retailNet} />
                                    </div>
                                    
                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Costi installazione:" value={quote.summary?.data.retailInstallationCosts} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale imponibile:" value={quote.summary?.data.retailTaxableAmount} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale iva:" value={quote.summary?.data.retailTotalTaxes} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale ordine:" value={quote.summary?.data.retailTotal} />
                                    </div>
                                </>
                            )}

                            {currentUser.isCustomer && (
                                <>
                                    <div className="my-1 text-center" style={{ lineHeight: "1" }}>
                                        <hr />
                                        {process.env.NODE_ENV != "production" && <small>Cliente finale</small>}
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Sconto:" value={-(quote.summary?.data.endClientTotalDiscount ?? 0)} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale merce netto:" value={quote.summary?.data.endClientNet} />
                                    </div>
                                    
                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Costi installazione:" value={quote.summary?.data.retailInstallationCosts} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale imponibile:" value={quote.summary?.data.endClientTaxableAmount} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale iva:" value={quote.summary?.data.endClientTotalTaxes} />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <AmountItem label="Totale ordine:" value={quote.summary?.data.endClientTotal} />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>}
                    
                    {selectedFiles.length > 0 && (<>
                        <div className="mt-2">
                            <h4 className="h4 fw-bold">Allegati:</h4>
                            {selectedFiles.map((file, index) => (
                            <div
                                key={file.guid}
                                className="flex items-center justify-between p-2 border rounded-md mb-1"
                            >
                                <span>{file.filename}</span>
                                <CloudDownloadIcon 
                                    className="text-red-500 cursor-pointer hover:text-red-700"
                                    onClick={() => dwAllegati(file.guid,file.filename)}
                                />
                            </div>
                            ))}
                        </div></>
                    )}
                </div>
                <div className="d-flex flex-row-reverse px-4 py-2">
                    {!isOrderSent() && <Button variant="contained" color="primary" size="small" className="ms-2" onClick={() => inviaOrdine()}>
                        <SendIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                        INVIA ORDINE
                    </Button>}

                    {currentUser.isCustomer && (
                        <Button variant="contained" color="primary" size="small" className="ms-2" onClick={(e) => {
                            window.open(`${process.env.REACT_APP_WEB_URL}/pergola-configurations/${id}/customer/pdf`);
                        }}>
                            <DownloadIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                            SCARICA COPIA CLIENTE
                        </Button>
                    )}

                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="ms-2"
                            onClick={() => {
                                buildPdf("retail");
                            }}
                        >
                        <DownloadIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                        SCARICA PREVENTVO
                    </Button>

                    {"not_started" == quote.summary?.data?.syncStatus && <Button variant="contained" color="secondary" size="small" onClick={() => resetPreventivo()}>
                        <RestartAltIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                        RESET
                    </Button>}
                </div>                 
            </div>
    </div>
    </>);
};